// create query from selection
export function createQuery(element) {
    if (element === null || element === void 0 ? void 0 : element.id)
        return `#${escapeCSSString(element.id)}`;
    if ((element === null || element === void 0 ? void 0 : element.localName) === "html")
        return "html";
    // Generate the query from the element
    const generateQuery = (el) => {
        if (!el)
            return "";
        // If the element has no parent, it is the root element
        // But sometimes the root element is #document so we need to handle that case as well
        if (!el.parentNode) {
            // if element is #document node return empty string
            if (el.nodeType === Node.DOCUMENT_TYPE_NODE)
                return "";
            // else just return the localName of the element
            return el.localName;
        }
        const parent = el.parentNode;
        // Skip #document node
        if (parent.nodeType === Node.DOCUMENT_NODE) {
            return "";
        }
        const parentSelector = generateQuery(parent);
        let query = "";
        // The element is a text node so we need to get the index of the text node in the parent
        if (!el.localName) {
            let index = 0;
            index = Array.prototype.indexOf.call(parent.childNodes, element);
            // fix query for text nodes
            // if theres already textNode:nth-of-type in the parentSelector, just change the index
            if (parentSelector.includes("textNode:nth-of-type(")) {
                const parentSelectorParts = parentSelector.split("textNode:nth-of-type(");
                const parentSelectorIndex = parseInt(parentSelectorParts[1].split(")")[0]);
                query = `${parentSelectorParts[0]}textNode:nth-of-type(${parentSelectorIndex + index})`;
            }
            else {
                query = `${parentSelector}>textNode:nth-of-type(${index})`;
            }
            // Is a normal element so we can just use the localName of the element and the nth-of-type
        }
        else {
            const index = Array.from(parent.childNodes)
                .filter((child) => child.localName === el.localName)
                .indexOf(el) + 1;
            query = `${parentSelector}>${el.localName}:nth-of-type(${index})`;
        }
        // Remove leading '>' if it exists
        if (query.startsWith(">")) {
            query = query.substring(1);
        }
        return query;
    };
    let query = generateQuery(element);
    return query;
}
function escapeCSSString(cssString) {
    return cssString.replace(/(:)/gu, "\\$1");
}
export function getContainer(selection) {
    let container = selection.getRangeAt(0).commonAncestorContainer;
    // Sometimes the element will only be text. Get the parent in that case
    while (!container.innerHTML && container.parentNode) {
        container = container.parentNode;
    }
    return container;
}
